import { useMutation, useQueryClient } from "@tanstack/react-query";
import tradeService from "../services/trade.service";
import toast from "react-hot-toast";

export const useDeleteScaleIn = () => {
  const queryClient = useQueryClient();

  const { isPending: isDeletingIn, mutate: deleteScaleIn } = useMutation({
    mutationFn: tradeService.deleteSacleIn,
    onSuccess: () => {
      toast.success("Scale in deleted successfully");
      queryClient.invalidateQueries({
        queryKey: ["trade"],
      });
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || "Something went wrong");
    },
  });

  return { isDeletingIn, deleteScaleIn };
};

export const useDeleteScaleOut = () => {
  const queryClient = useQueryClient();
  const { isPending: isDeletingOut, mutate: deleteScaleOut } = useMutation({
    mutationFn: tradeService.deleteSacleOut,
    onSuccess: () => {
      toast.success("Scale Out deleted successfully");
      queryClient.invalidateQueries({
        queryKey: ["trade"],
      });
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || "Something went wrong");
    },
  });

  return { isDeletingOut, deleteScaleOut };
};

export function useResetTrade() {
  const queryClient = useQueryClient();
  const { isPending: isReseting, mutate: resetTrade } = useMutation({
    mutationFn: tradeService.resetTrade,
    onSuccess: () => {
      toast.success("Trade reset successfully");
      queryClient.invalidateQueries({
        queryKey: ["trade"],
      });
    },
    onError: (err) => {
      toast.error(err.response?.data?.message || "Something went wrong");
    },
  });

  return { resetTrade, isReseting };
}
